import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { $userLanguage } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { useUnit } from 'effector-react'
import { AppButton } from '../../button'
import { featuresList } from '../constants'
import { format, parseISO } from 'date-fns'
import { FeatureTexts, SubscriptionLevel } from '../types'
import { Icon } from '../../icon'
type SubscribedDrawerProps = {
  handleHide?: () => void
  subscriptionLevel: number
  isOpenedEnough?: boolean
}
export const SubscribedUserDrawer = (props: SubscribedDrawerProps) => {
  const { classes } = useStyles()
  const { handleHide, subscriptionLevel } = props
  const userLang = useUnit($userLanguage)
  const userData = useUnit($steamUserData)
  const units = lang[userLang].pages.units
  const texts = lang[userLang].pages.main.subscriptionDrawer
  const validDate = userData?.userData?.gamed_premium_until
    ? format(parseISO(userData.userData.gamed_premium_until!), 'dd.MM.yyyy')
    : ''

  if (subscriptionLevel === SubscriptionLevel.PLUS) {
    return (
      <div className={classes.root}>
        <img
          src="https://storage.googleapis.com/gamed-games-bucket/pictures/stuff/drawerGlow.webp"
          className={classes.blurCircle}
        />
        <div className={classes.heading}>
          <div className={classes.logosWrapper}>
            <Icon
              view="plusLogo"
              style={{ height: '52px', width: '155px' }}
            />
          </div>
          <div className={classes.textWrapper}>
            <span>{texts.alreadyPlus}</span>
          </div>
        </div>
        <div className={classes.featureList}>
          <div>
            {featuresList.map((feature) => {
              return (
                <div
                  key={feature.name}
                  className={classes.featureListItem}
                >
                  <div className={classes.nameAndLogoWrapper}>
                    <div className={classes.imageIconWrapper}>
                      <img
                        src={feature.icon}
                        alt=""
                        width="32px"
                      />
                    </div>
                    <span className={classes.featureName}>
                      &nbsp;{texts.features[feature.name as keyof FeatureTexts]}
                    </span>
                  </div>
                  <div className={classes.availabilityWrapper}>
                    {feature.plusValue ? (
                      <span className={classes.valueText}>
                        {feature.plusValue} {units.hours}
                      </span>
                    ) : (
                      <Icon
                        view={feature.plusAvailability ? 'checkedGreen' : 'lock'}
                        style={commonIconStyle}
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>

        <div className={classes.controlsWrapper}>
          <AppButton
            onClick={handleHide}
            className={classes.button}
            fullWidth
          >
            <span>{lang[userLang].pages.btnTexts.time}</span>
          </AppButton>
          <span className={classes.validText}>
            {texts.valid} {validDate}
          </span>
        </div>
      </div>
    )
  }
  if (subscriptionLevel === SubscriptionLevel.PLATINUM) {
    return (
      <div className={classes.root}>
        <img
          src="https://storage.googleapis.com/gamed-games-bucket/pictures/stuff/drawerGlow.webp"
          className={classes.blurCircle}
        />
        <div className={classes.heading}>
          <div className={classes.logosWrapper}>
            <Icon
              view="platinum"
              style={{ height: '52px', width: '213px' }}
            />
          </div>
          <div className={classes.textWrapper}>
            <span>{texts.alreadyPlatinum}</span>
          </div>
        </div>
        <div className={classes.featureList}>
          <div>
            {featuresList.map((feature) => {
              return (
                <div
                  key={feature.name}
                  className={classes.featureListItem}
                >
                  <div className={classes.nameAndLogoWrapper}>
                    <div className={classes.imageIconWrapper}>
                      <img
                        src={feature.icon}
                        alt=""
                        width="32px"
                      />
                    </div>
                    <span className={classes.featureName}>
                      &nbsp;{texts.features[feature.name as keyof FeatureTexts]}
                    </span>
                  </div>
                  <div className={classes.availabilityWrapper}>
                    {feature.platinumValue ? (
                      <span
                        className={classes.valueText}
                        style={{ color: 'white' }}
                      >
                        {feature.platinumValue} {units.hours}
                      </span>
                    ) : (
                      <Icon
                        view={'checkedGreen'}
                        style={commonIconStyle}
                      />
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>

        <div className={classes.controlsWrapper}>
          <AppButton
            onClick={handleHide}
            className={classes.button}
            fullWidth
          >
            <span>{lang[userLang].pages.btnTexts.time}</span>
          </AppButton>
          <span className={classes.validText}>
            {texts.valid} {validDate}
          </span>
        </div>
      </div>
    )
  }
}

const commonIconStyle = {
  width: '16px',
  height: '16px',
  aspectRatio: '1/1',
}
